/**
 * Hard redirects (window.location) for the site root at https://greenlamcsrp.com/.
 * `PUBLIC_URL` matches package.json "homepage" (`/`).
 */
export function getLoginHref() {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  return base ? `${base}/login` : "/login";
}
